import React from 'react'
import classNames from 'classnames'

interface Props {
  children: React.ReactNode
  className?: string
}
export const ContentWidget = ({ children, className }: Props) => {
  const classes = classNames('content content--flat', className)
  return <div className={classes}>{children}</div>
}
